<script>
  import { onMount } from "svelte";
  import gsap from "gsap";

  // Tune variables
  const yModifier = 2;  // lower is larger Y differences
  const cursorAttract = 0.5;  // percentage of height
  const snapPercentage = 0.5;

  const coords = {x: 0, y: 0};
  let x = coords.x;
  let y = coords.y;
  let path;
  let connected = false;
  let resetting = false;
  let footerWidth = 0;
  let footerHeight = 0;
  let sensitivity = 0;
  let snapAt = 0;
  let initialized = false;
  let resetTimer;

  let footerColor = ["#5243f0", "#1c55f4"];
  let pageColor = "#ffffff";

  $: currentColorLeft = y > footerHeight ? pageColor : footerColor[0];
  $: currentColorRight = y > footerHeight ? pageColor : footerColor[1];

  function init() {
    footerWidth = document.querySelector(".footer")?.offsetWidth;
    footerHeight = document.querySelector(".footer")?.offsetHeight;
    y = coords.y = footerHeight;
    sensitivity = footerHeight * cursorAttract;
    snapAt = footerHeight * snapPercentage;
    initialized = true;
  }

  function update(targetX, targetY, ease, duration) {
    gsap.to(coords, {
        x: targetX,
        y: targetY,
        ease: ease,
        duration: duration,
        onUpdate: () => {
          x = coords.x;
          y = coords.y;
        },
        overwrite: true
    });
  }

  function handleMove(event) {
    if (!initialized) return;

    let realY = footerHeight - event.offsetY;
    let connectedY = Math.min(footerHeight - realY * 2, footerHeight * 1.3);
        connectedY = Math.max(connectedY, -footerHeight);
    let Y = Math.min(realY * yModifier, footerHeight * 1.3);
        Y = Math.max(Y, -footerHeight / 2);

    if (!connected && event.offsetY > footerHeight) {
      connected = true;
    }
    else if ((!resetting && connected) || event.target === path) {
      connected = true;
      update(event.offsetX, connectedY, "elastic.out(5, 0.4)", 6);
    }
    else if (!resetting && !connected && event.offsetY >= sensitivity) {
      update(event.offsetX, Y, "elastic.out(5, 0.4)", 6);
    }

    if (!resetting && connected && event.offsetY < snapAt) {
      reset(event);
    }
  }

  function reset(event) {
    resetting = true;
    update(event.offsetX, footerHeight, "elastic.out(2, 0.2)", 3);

    if (resetTimer) clearTimeout(resetTimer);
    resetTimer = setTimeout(() => {
      connected = false;
      resetting = false;
      }, 500);
  }

  onMount(() => setTimeout(init, 500));
</script>

<style>
  svg {
    position: fixed;
    width: 100%;
    bottom: 0;
  }
</style>

<svelte:window on:resize={() => setTimeout(init, 100)} />

{#if initialized}
  <svg on:mousemove={handleMove} style="height: {footerHeight * 2}px;">
    <linearGradient id="gradient_footer">
      <stop style="stop-color: {currentColorLeft};" offset="0%"/>
      <stop style="stop-color: {currentColorRight};" offset="100%"/>
    </linearGradient>

    <path bind:this={path} style="fill: url(#gradient_footer);" d="
    M 0 {footerHeight}
    Q {x} {y}, {footerWidth} {footerHeight}
    z
    "></path>
  </svg>
{/if}
